import React, { useEffect, useState } from 'react'
import { TwitterPicker } from 'react-color'
import { Input } from '../../Components'

import './ColorPicker.css'

/**
 * 
 * @param {*} param0 
 * @returns 
 */
export function ColorPicker({ 
		defaultColor = '#0013ce',
		onComplete = () => {} // callback when we choose the color from the picker 
	}) {

	const [displayColorPicker, setDisplayColorPicker] = useState(false)
	const [color, setColor] = useState('')

	useEffect(() => {
		setColor(defaultColor)	
	}, [])
	
	
	const triggerColorPicker = () => {
        setDisplayColorPicker(!displayColorPicker);
    }

    const handleChangeBackgroundColor = (color) => {
        setColor(color.hex)
		onComplete(color.hex)
    }

	const handleClose = () => {
		setDisplayColorPicker(false)
	}

    const handleChangeInput = (e) => {
        setColor(e.target.value)
		onComplete(e.target.value)
    }

	return (
		<>
			<div className='color_picker-wrapper' >
                <div className="color_picker-trigger" 
				    style={{ backgroundColor : color ?? '#0013ce'}} 
				    onClick={triggerColorPicker}></div>
                <input
                    type={`text`} 
                    className="color_picker-trigger-code"
                    value={color}
                    onChange={handleChangeInput}
                    />
            </div> 
			{
				displayColorPicker && 
				<div className="color_picker-popover" >
					<div className='color_picker_cover' onClick={ handleClose }/>
					<TwitterPicker 
                        colors={['#FF6900', '#FCB900' , '#7BDCB5' , '#00D084','#8ED1FC' , '#0693E3' , '#ABB8C3' , '#EB144C' , '#F78DA7' , '#9900EF' , '#ffffff']} 
						color={ color }
						onChangeComplete={ handleChangeBackgroundColor }
						/>
				</div>
			}
		</>
	)
}
